// this is an autogenerated file from App/Account/Content/Settings/Content/ConnectApps/App/Content/Connections/Content/ActionsColumn/ToggleLocationConnection/SetupAutomations/Content/Content/Content/Steps/Content/ActiveStep/Automation/Event/TreatmentStatusUpdate/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Settings_Content_ConnectApps_App_Content_Connections_Content_ActionsColumn_ToggleLocationConnection_SetupAutomations_Content_Content_Content_Steps_Content_ActiveStep_Automation_Event_TreatmentStatusUpdate{
  vaxiom_tx_statuses(
    where: { hidden: { _eq: false } }
    order_by: { name: asc_nulls_last }
  ) {
    id: type
    text: name
  }
}

`